import React, { useEffect, useState } from "react";
import "./editAssociation.scss";

import HeaderBar from "../../components/headerBar/HeaderBar";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import ListTopic from "../../components/listTopic/ListTopic";

import { Button, Form, Image } from "react-bootstrap";
import { t } from "i18next";
import { useNavigate, useParams } from "react-router-dom";
import { setGlobalState } from "../../utils/state";
import { gestioneSnackbar } from "../../utils/common";
import { isEmpty, base64ToBlob, isValidUrl } from "../../utils/validation";
import {
  getAllTopicWS,
  getAssociationWS,
  updateAssociationWS,
} from "./api/editAssociationApi";
import {
  daProvinciaASigla,
  daSiglaAProvincia,
  province,
} from "../../enums/province";
import moment from "moment/moment";

const EditAssociation = () => {
  const navigate = useNavigate();
  const { id_association } = useParams();

  const [listTopic, setListTopic] = useState([]);
  const [file, setFile] = useState(null);

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [indirizzo, setIndirizzo] = useState("");
  const [comune, setComune] = useState("");
  const [provincia, setProvincia] = useState("");
  const [siteWeb, setSiteWeb] = useState("");
  const [dateOfFoundation, setDateOfFoundation] = useState("");
  const [image, setImage] = useState(null);
  const [topic, setTopic] = useState([]);

  useEffect(() => {
    setGlobalState("selectedIdBottomBar", 2);

    getAssociationWS({ id_association })
      .then((res) => {
        console.log(res);
        setName(res.name);
        setDescription(res.description);
        setDateOfFoundation(
          moment(res.date_of_foundation, "DD/MM/YYYY").format("YYYY-MM-DD")
        );
        const address = res.address.split(", ");
        setIndirizzo(address[0]);
        setComune(address[1]);
        setProvincia(daSiglaAProvincia[address[2]]);
        setSiteWeb(res.site_web ? res.site_web : "");
        setImage(
          res.image ? "data:" + res.image_type + ";base64," + res.image : null
        );
        setTopic(res.topic.map((item) => item.id));
      })
      .catch((err) => console.error(err));

    getAllTopicWS()
      .then((res) => setListTopic(res))
      .catch((err) => console.error(err));
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type.startsWith("image/")) {
        setFile(file);
        setImage(URL.createObjectURL(file));
      } else {
        gestioneSnackbar(true, t("validation.only_one_image"), "error");
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!file && !image) {
      gestioneSnackbar(true, t("edit_association.void_image"), "error");
      return;
    }

    if (isEmpty(name)) {
      gestioneSnackbar(true, t("edit_association.void_name"), "error");
      return;
    }

    if (isEmpty(description)) {
      gestioneSnackbar(true, t("edit_association.void_description"), "error");
      return;
    }

    if (
      isEmpty(dateOfFoundation) ||
      moment(dateOfFoundation).isAfter(moment())
    ) {
      gestioneSnackbar(
        true,
        t("edit_association.void_date_of_foundation"),
        "error"
      );
      return;
    }

    if (isEmpty(comune) || isEmpty(indirizzo) || isEmpty(provincia)) {
      gestioneSnackbar(true, t("edit_association.void_address"), "error");
      return;
    }

    if (!isEmpty(siteWeb) && !isValidUrl(siteWeb)) {
      gestioneSnackbar(true, t("edit_association.not_valid_site_web"), "error");
      return;
    }

    const formData = new FormData();

    if (file) {
      formData.append("profile_image", file); // Selezionato dall'utente
    } else if (image.startsWith("data:image")) {
      const blob = base64ToBlob(image);
      formData.append("profile_image", blob, "image.png"); // Convertito da base64
    }

    formData.append("name", name);
    formData.append("description", description);
    formData.append(
      "address",
      indirizzo + ", " + comune + ", " + daProvinciaASigla[provincia]
    );
    formData.append("date_of_foundation", dateOfFoundation);
    formData.append("site_web", siteWeb);
    formData.append("topics", topic.toString());

    updateAssociationWS({ id_association, formData })
      .then((res) => {
        gestioneSnackbar(true, res.message, "success");
        URL.revokeObjectURL(image);
        navigate("/dashboard/" + id_association, { replace: true });
      })
      .catch((err) => {
        gestioneSnackbar(true, err.title, "error");
      });
  };

  return (
    <>
      <HeaderBar
        title={t("edit_association.title")}
        back={true}
        path={"/dashboard/" + id_association}
      />
      <Form onSubmit={handleSubmit}>
        <div className="edit-association-container container-responsive ">
          <div className="input-container">
            <Form.Group className="mb-2" controlId="formBasicEmail">
              <Form.Label>{t("edit_association.name_association")}</Form.Label>
              <Form.Control
                type="text"
                maxLength={50}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
          </div>
          <div className="input-container">
            <Form.Group
              className="mb-2"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>{t("edit_association.description")}</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                maxLength={1000}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Group>
          </div>
          <div className="input-container">
            <Form.Group
              className="mb-2"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>{t("edit_association.address")}</Form.Label>
              <Form.Control
                type="text"
                maxLength={150}
                value={indirizzo}
                onChange={(e) => setIndirizzo(e.target.value.replace(/,/g, ""))}
              />
            </Form.Group>
            <Form.Group
              className="mb-2"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>{t("edit_association.country")}</Form.Label>
              <Form.Control
                type="text"
                maxLength={60}
                value={comune}
                onChange={(e) => setComune(e.target.value)}
              />
            </Form.Group>
            <Form.Group
              className="mb-2"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>{t("edit_association.provincia")}</Form.Label>
              <Form.Select
                value={provincia}
                onChange={(e) => setProvincia(e.target.value)}
              >
                <option value="">{t("edit_association.provincia")}</option>
                {province.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
          <div className="input-container">
            <Form.Group
              className="mb-2"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>{t("edit_association.site_web")}</Form.Label>
              <Form.Control
                placeholder="https://..."
                type="text"
                value={siteWeb}
                onChange={(e) => setSiteWeb(e.target.value)}
              />
            </Form.Group>
          </div>
          <div className="input-container">
            <Form.Group
              className="mb-2"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>
                {t("edit_association.date_of_foundation")}
              </Form.Label>
              <Form.Control
                type="date"
                value={dateOfFoundation}
                onChange={(e) => setDateOfFoundation(e.target.value)}
              />
            </Form.Group>
          </div>
          <div className="input-container">
            <Form.Group controlId="imageUpload">
              <Form.Label>{t("edit_user.select_image")}</Form.Label>
              <Form.Control
                type="file"
                accept="image/*" // Limita solo ai file di tipo immagine
                onChange={handleImageChange}
              />
            </Form.Group>
            {image && (
              <div className="selected mt-3">
                <Image
                  src={image}
                  alt="Preview"
                  thumbnail
                  style={{ maxWidth: "200px" }}
                />
              </div>
            )}
          </div>

          {!isEmpty(listTopic) ? (
            <ListTopic
              data={listTopic}
              disabled={false}
              title={t("edit_association.topics")}
              selected={topic}
              setSelected={setTopic}
            />
          ) : null}

          <div className="button-container">
            <Button variant="success" type="submit">
              {t("common.save")}
            </Button>
          </div>
          <VoidSpace />
        </div>
      </Form>
    </>
  );
};

export default EditAssociation;
